/**
 * Client-side pricing calculation — mirrors the Python backend logic
 */

export function calculateCostClientSide(
  modelType: string,
  modelValue: number,
  amountRaised: number,
  sbCost: number,
  delivered: number
): number {
  switch (modelType) {
    case 'roi_guarantee':
      return modelValue > 0 ? amountRaised / (modelValue / 100) : 0;
    case 'profit_share': {
      const profit = Math.max(0, amountRaised - sbCost);
      const fee = profit * (modelValue / 100);
      const cost = sbCost + fee;
      // Client never pays more than they raised — no profit means no loss
      return amountRaised > 0 ? Math.min(cost, amountRaised) : 0;
    }
    case 'fixed_cost':
      return delivered * modelValue;
    case 'free':
    case 'incomplete_setup':
      return 0;
    default:
      return 0;
  }
}

export function formatModelLabel(modelType: string, modelValue: number): string {
  switch (modelType) {
    case 'roi_guarantee':
      return `${modelValue}% ROI Guarantee`;
    case 'profit_share':
      return `${modelValue}% Profit Share`;
    case 'fixed_cost':
      return `$${modelValue} Fixed Cost`;
    case 'free':
      return 'Free';
    case 'incomplete_setup':
      return 'Incomplete Setup';
    default:
      return 'Fixed Cost';
  }
}

/** Pricing models that carry no numeric value, so the UI hides the value input.
 *  Mirrors _VALUELESS_MODEL_TYPES in flask-api/app.py -- keep the two in sync. */
export const VALUELESS_MODEL_TYPES = new Set(['free', 'incomplete_setup']);

export function modelHasValue(modelType?: string | null): boolean {
  return !!modelType && !VALUELESS_MODEL_TYPES.has(modelType);
}
